module.exports = function() {
  return new Worker(__webpack_public_path__ + "05cb969bbf5a478ba5b4.worker.js");
};